// Codes courts de partie (doc 02 §4 / doc 04 §4) : 31 caractères, sans 0/O ni 1/I/L.
export const CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
// Longueur 4 au lancement, extensible sans migration : le validateur accepte 4–6.
export const CODE_LENGTH = 4;
export const CODE_LENGTH_MIN = 4;
export const CODE_LENGTH_MAX = 6;
export const GAME_CODE_REGEX = new RegExp(
  `^[${CODE_ALPHABET}]{${CODE_LENGTH_MIN},${CODE_LENGTH_MAX}}$`,
);

// Delta de score borné ±999, ≠ 0 (arbitrage doc 00 §4.15, CHECK SQL doc 04 §1.6)
export const DELTA_MIN = -999;
export const DELTA_MAX = 999;

// Pseudo participant (doc 04 §1.5 : CHECK BETWEEN 2 AND 20)
export const NICKNAME_MIN = 2;
export const NICKNAME_MAX = 20;

export const LOCALES = ['fr', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

// doc 04 §1.3
export const GAME_STATUSES = ['active', 'paused', 'ending', 'ended', 'archived'] as const;
export type GameStatus = (typeof GAME_STATUSES)[number];

export const VERTICALS = ['blindtest', 'quiz', 'sport', 'classe', 'teambuilding', 'jeux'] as const;
export type Vertical = (typeof VERTICALS)[number];

export const SCORING_MODES = ['teams', 'individual'] as const;
export type ScoringMode = (typeof SCORING_MODES)[number];

// Origines de la boucle virale (doc 06 §7.3) — colonne `acquisition_events.src`.
// Ce sont NOS paramètres, pas des UTM Google : vocabulaire fermé, une seule liste
// pour la vitrine, la webapp et l'API. Le display, lui, n'émet que `display`.
export const ACQUISITION_SOURCES = [
  'display',
  'join',
  'endgame',
  'share',
  'seo',
  'store',
  'direct',
] as const;
export type AcquisitionSource = (typeof ACQUISITION_SOURCES)[number];
